// This theme is served behind a reverse proxy from two domains — the blog
// lives at https://ozegen.ai/ and at https://marketplace.ozegen.ai/blog/ —
// and the proxy is a true pass-through, so the browser's address bar always
// keeps the original domain. Production can therefore always tell the two
// sites apart by hostname alone; see detectSite() below.
//
// This is a plain <script> tag that runs on every full page load (there's
// no client-side routing here), so detection and the nav/footer swap happen
// fresh on every navigation and every reload — there's no state to keep in
// sync between page loads other than the optional preview override below.
(function () {
    const marketplaceNav = document.getElementById('ipeo-navigation');
    if (!marketplaceNav) return;

    const ozegenNav = document.getElementById('ozegen-navbar');
    const marketplaceFooter = document.getElementById('ipeo-footer');
    const ozegenFooter = document.getElementById('ozegen-footer');

    const MARKETPLACE_URL = marketplaceNav.dataset.marketplaceBaseUrl || 'https://marketplace.ozegen.ai';
    const OZEGEN_URL = marketplaceNav.dataset.ozegenBaseUrl || 'https://ozegen.ai';

    function hostnameOf(url) {
        try {
            return new URL(url).hostname;
        } catch (e) {
            return null;
        }
    }

    const OZEGEN_HOSTNAME = hostnameOf(OZEGEN_URL);

    const PREVIEW_PARAM = 'ipeoSite';
    const PREVIEW_STORAGE_KEY = 'ipeoSitePreview';

    // Anywhere that isn't actually served behind the proxy (local dev, a
    // staging tunnel, ...) has no real hostname to detect from. Force a site
    // with ?ipeoSite=ozegen or ?ipeoSite=marketplace in the URL. Once set,
    // it's kept in sessionStorage so it survives clicking to other pages
    // during that tab's session, without leaking into other origins/tabs
    // or persisting after the tab closes.
    function detectSite() {
        const requested = new URLSearchParams(window.location.search).get(PREVIEW_PARAM);
        if (requested === 'ozegen' || requested === 'marketplace') {
            try {
                sessionStorage.setItem(PREVIEW_STORAGE_KEY, requested);
            } catch (e) {
                // Storage disabled (private mode, browser settings, ...) — the
                // override just won't survive to the next page, which is fine.
                console.debug('[source-detection] sessionStorage unavailable, preview override will not persist:', e);
            }
            return requested;
        }

        let stored = null;
        try {
            stored = sessionStorage.getItem(PREVIEW_STORAGE_KEY);
        } catch (e) {
            // Same as above — fall through to hostname-based detection below.
            console.debug('[source-detection] sessionStorage unavailable, falling back to hostname detection:', e);
        }
        if (stored === 'ozegen' || stored === 'marketplace') {
            return stored;
        }

        return window.location.hostname === OZEGEN_HOSTNAME ? 'ozegen' : 'marketplace';
    }

    const isOzegen = detectSite() === 'ozegen';

    console.info('[source-detection] site=%s hostname=%s ozegenHostname=%s', isOzegen ? 'ozegen' : 'marketplace', window.location.hostname, OZEGEN_HOSTNAME);

    // Marketplace nav/footer are visible by CSS default, so only the ozegen
    // ones need an explicit display value to override their `display: none`
    // default (see .ozegen-navbar / .ozegen-footer in screen.css).
    marketplaceNav.style.display = isOzegen ? 'none' : '';
    if (marketplaceFooter) marketplaceFooter.style.display = isOzegen ? 'none' : '';
    if (ozegenFooter) ozegenFooter.style.display = isOzegen ? 'block' : 'none';
    if (ozegenNav) {
        ozegenNav.style.display = isOzegen ? 'block' : 'none';
        if (isOzegen) ozegenNav.style.top = '0'; // no marketplace navbar stacked above it
    }

    const siteUrl = isOzegen ? OZEGEN_URL : MARKETPLACE_URL;

    // Tell the panel app where to send the visitor back to after signing in
    document.querySelectorAll('[data-append-next]').forEach(function (link) {
        const url = new URL(link.getAttribute('href'), window.location.href);
        url.searchParams.set('next', siteUrl);
        link.setAttribute('href', url.toString());
    });

    // Always point "Dodaj działkę" CTAs at the real marketplace URL
    document.querySelectorAll('[data-marketplace-link]').forEach(function (link) {
        const action = link.getAttribute('data-marketplace-link');
        const url = new URL(MARKETPLACE_URL);
        url.searchParams.set('action', action);
        link.setAttribute('href', url.toString());
    });
})();
